import { useContext, useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import logo from "../assets/images/Datara_Icon_Black.png";
import logo_cuted from "../assets/images/Datara_Cuted.png";
import Context from "../context/Context";
import Cookies from 'js-cookie';
import { adminSidebar } from "./common/sidebarContent";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
const ACCENT_COLOR_BG = 'bg-[#fff]';


const Sidebar2 = () => {
    const { user, adminDashboardTab, isSidebarOpen, setSidebarOpen } = useContext(Context);
    const [openDropdown, setOpenDropdown] = useState(null);
    const token = Cookies.get('adminToken');
    const navigate = useNavigate();
    const location = useLocation();

   const getActualSidebar = () => {
        if (user?.role === 'superuser') {
            let sidebar = [...adminSidebar];
            if (adminDashboardTab !== 'Enterprise') {
                sidebar = sidebar.filter(item => item.name !== 'Requests');
            }
            if (adminDashboardTab === 'Business') {
                const settingsIndex = sidebar.findIndex(item => item.name === 'Settings');
                if (settingsIndex !== -1) {
                    sidebar.splice(settingsIndex, 1);
                }
            }
            return sidebar;
        }
    };

    const actualSidebar = getActualSidebar();

    const toggleSidebar = () => {
        setSidebarOpen(!isSidebarOpen);
    };

    const handleItemClick = () => {
        localStorage.removeItem('breadcrumb');
        setOpenDropdown(null);
    }

    useEffect(() => {
        actualSidebar?.forEach((item, index) => {
            if (item.children) {
                const hasActiveChild = item.children.some(child => child.link === location.pathname);
                if (hasActiveChild) {
                    setOpenDropdown(index);
                }
            }
        });
    }, [location.pathname, actualSidebar]);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 768) {
                setSidebarOpen(false);
            } else {
                setSidebarOpen(true);
            }
        };

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, [setSidebarOpen]);

    useEffect(() => {
        if (!token) {
             Cookies.remove('adminToken');
            navigate('/login');
        }
    }, [token]);

    return (
        <div className={`sidebar z-40 ${isSidebarOpen ? "open" : ""}`}>
            {!isSidebarOpen && <i className={`icon ${isSidebarOpen ? " mt-4" : "flex items-center justify-center gap-1"} ml-[17px]`}>
                <img
                    src={logo}
                    alt="logo"
                    height={30}
                    width={30}
                    style={{ filter: 'invert(1)' }}
                />
                <i
                    className={`flex bx ${isSidebarOpen ? "bx-menu-alt-right" : "flex items-center cursor-pointer"} bx-sm`}
                    id="btn"
                    onClick={toggleSidebar}
                ><MdKeyboardArrowRight size={23} /></i>
            </i>}
            <div className="logo-details ">
                {isSidebarOpen && <i className={`icon ${isSidebarOpen ? "" : " "} mt-4 ml-1`}>
                    <img
                        src={logo}
                        alt="logo"
                        height={30}
                        width={30}
                        style={{ filter: 'invert(1)' }}
                    />
                </i>}
                {isSidebarOpen && (
                    <div className="logo_container ml-2 mb-2">
                        <img
                            src={logo_cuted}
                            alt="logo_cuted"
                            style={{ filter: 'invert(1)' }}
                        />
                    </div>
                )}

                {isSidebarOpen && <i
                    //  className={`flex bx ${isSidebarOpen ? "bx-menu-alt-right" : "bx-menu"} bx-sm`}
                    className="flex items-center justify-center"
                    id="btn"
                    onClick={toggleSidebar}
                ><MdKeyboardArrowLeft />
                </i>}
            </div>

            <ul className={`nav-list flex-grow overflow-y-auto overflow-x-hidden custom-sidebar-scroll ${!isSidebarOpen && 'mt-[-60px]'}`}>
                {actualSidebar?.map((item, index) => (
                    <li key={index} className={`sidebar-item cursor-pointer ${isSidebarOpen && '!pl-[8px]'}`}>
                        {item.children ? (
                            <>
                                <div
                                    className={`sidebar-parent flex items-center justify-between ${openDropdown === index ? "active" : ""}`}
                                    onClick={() => setOpenDropdown(openDropdown === index ? null : index)}
                                >
                                    <div className="d-flex align-items-center w-full">
                                        {typeof item.icon === "string" ? (
                                            <i className={`bx ${item.icon} sidebar-icon`}></i>
                                        ) : (
                                            <i className={`flex items-center ${!isSidebarOpen ? 'justify-center w-full' : ''}`}><item.icon size={18} className="sidebar-icon" /></i>
                                        )}
                                        <div className="flex items-center justify-between w-full">
                                        {isSidebarOpen && <span className="links_name ">{item.name}</span>}
                                        <i className={`flex bx bx-chevron-${openDropdown === index ? "down" : "right"} `}></i>
                                        </div>
                                    </div>

                                </div>
                                {openDropdown === index && (
                                    <ul className="submenu">
                                        {item.children.map((child, childIndex) => (
                                            <li key={childIndex}>
                                                <Link
                                                    to={child.link}
                                                    className={location.pathname === child.link ? "active-link" : ""}
                                                    onClick={handleItemClick}
                                                >
                                                    {typeof child.icon === "string" ? (
                                                        <i className={`bx ${child.icon} sidebar-icon `}></i>
                                                    ) : (
                                                        <i className={`flex items-center ${!isSidebarOpen ? 'justify-center w-full' : 'justify-center'}`}><child.icon size={18} className="sidebar-icon ml-1" /></i>
                                                    )}
                                                    <span className="links_name ">{child.name}</span>
                                                </Link>
                                                <span className="tooltip">{child?.name}</span>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </>
                        ) : (
                            <Link
                                to={item.link}
                                className={`${(location.pathname === item.link && openDropdown === null) ? "active-link" : ""} ${!isSidebarOpen ? 'justify-center' : ''}`}
                                onClick={handleItemClick}
                            >
                                {typeof item.icon === "string" ? (
                                    <i className={`bx ${item.icon} `}></i>
                                ) : (
                                    <i className={`flex items-center ${!isSidebarOpen ? 'justify-center w-full' : 'justify-center'}`}><item.icon size={18} className="sidebar-icon " /></i>
                                )}
                                {isSidebarOpen && <span className="links_name ">{item.name}</span>}
                            </Link>
                        )}
                        {openDropdown !== index && <span className="tooltip">{item?.name}</span>}
                    </li>
                ))}

            </ul>

        </div>
    );
};

export default Sidebar2;
